import { ReportWithRelations } from "../../bookmydesk-api-sdk-typescript-axios";
import { kLocations } from "./locations";
import { kReportReasons } from "./report-reasons";
import { kUsers } from "./users";

export const kReports: ReportWithRelations[] = [
  {
    id: "a1b2c3d4-e5f6-4789-8123-567890abcdef",
    reason: kReportReasons[0],
    user: kUsers[0],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-09T01:46:13.1313",
    details:
      "The small desk fan next to my workstation (B11) is not turning on. It's quite stuffy here, and it's making it difficult to concentrate.",
  },
  {
    id: "b9a87654-3210-4fed-ba98-76543210fedc",
    reason: kReportReasons[1],
    user: kUsers[1],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-04-01T08:23:23.2323",
    details:
      "The overhead fluorescent light fixture closest to Desk C5 has been flickering intermittently all day. It's quite distracting and causing eye strain.",
  },
  {
    id: "cdef0123-4567-489a-bcde-0123456789ab",
    reason: kReportReasons[2],
    user: kUsers[2],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-26T03:50:17.1717",
    details:
      "The power outlet on the wall to the left of the projector screen in Meeting Room 2 is not working. We tried multiple devices, and none are receiving power.",
  },
  {
    id: "98765432-10fe-4dcba-9876-543210fedcba",
    reason: kReportReasons[3],
    user: kUsers[3],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-03-06T09:20:05.055",
    details:
      "The gas lift on my chair at Desk A2 is no longer working. The chair keeps sinking to the lowest position, which is not ergonomic for me.",
  },
  {
    id: "ef012345-6789-4abcd-ef01-23456789abcd",
    reason: kReportReasons[4],
    user: kUsers[4],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-03-03T04:51:59.5959",
    details:
      "The surface of Hot Desk 4 has a large, deep scratch that catches my wrist while I'm typing. It's quite uncomfortable.",
  },
  {
    id: "89abcdef-0123-4567-89ab-cdef01234567",
    reason: kReportReasons[5],
    user: kUsers[5],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-03-16T07:12:52.5252",
    details:
      "The external monitor connected to Shared Workstation 7 is not displaying any signal. The power light is on, but the screen remains black.",
  },
  {
    id: "f0e9d8c7-b6a5-4321-fedc-ba9876543210",
    reason: kReportReasons[6],
    user: kUsers[6],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-20T03:25:40.4040",
    details:
      "Several keys on the keyboard at IT Support Desk 1 are sticking and not registering properly, particularly the 'e' and 's' keys.",
  },
  {
    id: "12345678-90ab-4cdef-1234-567890abcdef01",
    reason: kReportReasons[7],
    user: kUsers[7],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-02-28T10:00:25.2525",
    details:
      "I am unable to get a wired network connection at Desk D15. The Ethernet cable is plugged in, but my laptop is not recognizing a connection. Wi-Fi is working, but I prefer a wired connection for stability.",
  },
  {
    id: "23456789-0abc-4def-2345-67890abcdef012",
    reason: kReportReasons[8],
    user: kUsers[8],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-27T02:44:23.2323",
    details:
      "The desk phone at the Reception Desk is not getting a dial tone. This is preventing us from receiving incoming calls.",
  },
  {
    id: "34567890-abcd-4ef1-3456-7890abcdef0123",
    reason: kReportReasons[9],
    user: kUsers[9],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-02-15T04:21:52.5252",
    details:
      'The multi-function printer on the third floor has a paper jam. The error message on the screen says "Paper Jam in Tray 2".',
  },
  {
    id: "4567890a-bcde-4f01-4567-890abcdef01234",
    reason: kReportReasons[10],
    user: kUsers[10],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-15T07:04:03.033",
    details:
      "The projector in Training Room 1 is not turning on. We have a training session scheduled to start shortly and need it to display our presentation.",
  },
  {
    id: "567890ab-cdef-4012-5678-90abcdef012345",
    reason: kReportReasons[11],
    user: kUsers[11],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-02-28T12:24:37.3737",
    details:
      "The whiteboard in Collaboration Zone A is very difficult to erase. Markers leave faint but visible marks, making it hard to reuse the surface.",
  },
  {
    id: "67890abc-def0-4234-6789-0abcdef0123456",
    reason: kReportReasons[12],
    user: kUsers[12],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-03-30T09:11:26.2626",
    details:
      "The lock on my assigned locker, #27, seems to be jammed. I am unable to open it.",
  },
  {
    id: "7890abcd-ef01-4345-7890-abcdef01234567",
    reason: kReportReasons[13],
    user: kUsers[13],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-02-23T07:59:51.5151",
    details:
      "The area around Desk E3, which is near the large window, is significantly colder than the rest of the office. There seems to be a draft.",
  },
  {
    id: "890abcdef-0123-4567-890a-bcdef012345678",
    reason: kReportReasons[14],
    user: kUsers[14],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-03-25T05:50:33.3333",
    details:
      "The cold water tap in the kitchenette on the second floor is constantly dripping, even when fully turned off.",
  },
  {
    id: "90abcdef0-1234-4567-90ab-cdef0123456789",
    reason: kReportReasons[15],
    user: kUsers[15],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-02-14T06:57:12.1212",
    details:
      "There is a large coffee spill on the table next to the coffee machine in the break room. It needs to be cleaned up.",
  },
  {
    id: "0abcdef01-2345-4678-0abc-def0123456789a",
    reason: kReportReasons[16],
    user: kUsers[16],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-02T10:11:51.5151",
    details:
      "Several slats on the blinds in Meeting Room 4 are broken and bent, affecting the amount of light we can block out.",
  },
  {
    id: "abcdef012-3456-4789-abcd-ef0123456789ab",
    reason: kReportReasons[17],
    user: kUsers[17],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-02-26T06:23:05.055",
    details:
      "There is a loose network cable running across the walkway near the printer on the first floor. It's a trip hazard.",
  },
  {
    id: "bcdef0123-4567-489a-cdef-0123456789abc",
    reason: kReportReasons[18],
    user: kUsers[18],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-03-01T11:43:20.2020",
    details:
      "The door to the toilet cubicle furthest from the entrance in the Ladies' on the fourth floor is not closing and latching properly.",
  },
  {
    id: "cdef01234-5678-49ab-def0-123456789abcd",
    reason: kReportReasons[19],
    user: kUsers[19],
    location: kLocations[0],
    locationId: kLocations[0].id,
    created: "2025-01-05T03:17:34.3434",
    details:
      'The sign indicating the entrance to the "Quiet Zone" on the third floor is very faded and difficult to read.',
  },
];
